import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { useUserTier } from "@/hooks/useUserTier";

export function useTrialLimit() {
  const { user } = useAuth();
  const { tier, isLoading: tierLoading } = useUserTier();

  const { data, isLoading: countLoading } = useQuery({
    queryKey: ["invoice-count-month", user?.id],
    enabled: !!user,
    queryFn: async () => {
      // Count only invoices created in the current calendar month
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1).toISOString();
      const { count, error } = await supabase
        .from("invoices")
        .select("*", { count: "exact", head: true })
        .eq("user_id", user!.id)
        .gte("created_at", startOfMonth);
      if (error) throw error;
      return count ?? 0;
    },
  });

  const invoiceCount = data ?? 0;
  const limit = tier?.monthly_invoice_limit ?? null; // null = unlimited
  const hasReachedLimit = limit !== null ? invoiceCount >= limit : false;
  const remaining = limit !== null ? Math.max(0, limit - invoiceCount) : Infinity;
  const isUnlimited = limit === null;

  return {
    invoiceCount,
    hasReachedLimit,
    remaining,
    isLoading: countLoading || tierLoading,
    limit,
    isUnlimited,
  };
}
